import React from "react";
import { Navigate } from "react-router";
import AuthorizedLayout from "../App/AuthorizedLayout/AuthorizedLayout";
import useAppContext from "../App/useAppContext";
import { rootPaths } from "./routesPaths";

const AuthorizedRoute = ({ children }) => {
  const token = useAppContext().userToken;

  if (!token) {
    return <Navigate to={rootPaths.LOGIN} replace />;
  }

  return <AuthorizedLayout>{children}</AuthorizedLayout>;
};

export default AuthorizedRoute;
